import clsx from "clsx";
import { motion } from "motion/react";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSetRecoilState } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import {
  IReportMenuItemTranslated,
  reportsNavigationDrawerAtom,
  usePrefixedRouting,
} from "@ryde/shared";

import { getReportCategoryIcon } from "../parts";
import { reportAnimationVariants } from "./report-navigation.animations";
import { ReportNavigationItemStyled } from "./report-navigation.styled";

export const ReportNavigationItem: FC<IReportMenuItemTranslated> = ({
  titleTranslated,
  ownerCategory,
  active,
  id,
}) => {
  const setReportNavigationDrawerOpenState = useSetRecoilState(
    reportsNavigationDrawerAtom,
  );
  const { t } = useTranslation();
  const { addPrefix } = usePrefixedRouting();
  const href = useMemo(() => {
    return `/reports/${id}/table`;
  }, [id]);

  const handleLinkClick = (): void => {
    if (!id) {
      return;
    }

    setReportNavigationDrawerOpenState(false);
  };

  const handleItemAreaClick = (): void => {
    if (id) {
      return;
    }

    setReportNavigationDrawerOpenState(false);
  };

  return (
    <ReportNavigationItemStyled
      as={motion.div}
      variants={reportAnimationVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      onClick={handleItemAreaClick}
    >
      {Boolean(href) && (
        <>
          {ownerCategory && (
            <FramerTooltip content={t(`selectListLabel.${ownerCategory}`)}>
              <>{getReportCategoryIcon(ownerCategory)}</>
            </FramerTooltip>
          )}
          <Link
            to={addPrefix(href)}
            onClick={handleLinkClick}
            className={clsx({ active })}
          >
            <span className="report_title">{titleTranslated}</span>
          </Link>
        </>
      )}

      <SVG_MUI.ArrowsToDottedLineSVG className="arrow_item rtl_rotate" />
    </ReportNavigationItemStyled>
  );
};
